var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    fill: "none",
    viewBox: "0 0 14 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB800",
    d: "m2.008 11.977.96-3.815a.357.357 0 0 0 0-.201.56.56 0 0 0-.095-.183L.123 4.857a.43.43 0 0 1-.115-.201.5.5 0 0 1 .02-.237c.038-.073.076-.147.153-.183.058-.055.154-.073.23-.091l4.115-.292a.456.456 0 0 0 .212-.055.571.571 0 0 0 .153-.146L6.93.219a.368.368 0 0 1 .174-.164.534.534 0 0 1 .23-.055c.077 0 .154.037.23.073.059.055.116.11.155.183l1.576 3.633c.02.073.077.128.135.164a.614.614 0 0 0 .192.092l4.038.84a.466.466 0 0 1 .211.11.429.429 0 0 1 .116.419.47.47 0 0 1-.135.2l-3.134 2.539a.328.328 0 0 0-.115.164.628.628 0 0 0-.039.201l.423 3.907c0 .073 0 .165-.038.238a.44.44 0 0 1-.154.164.56.56 0 0 1-.23.073.476.476 0 0 1-.231-.055l-3.519-2.063a.403.403 0 0 0-.211-.055c-.077 0-.135 0-.212.037l-3.768 1.588a.336.336 0 0 1-.231.018.436.436 0 0 1-.211-.09c-.058-.056-.116-.11-.135-.183-.058-.073-.058-.146-.038-.22Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cd5531af886c4502afd3bb6e472b027a.svg";
export { ForwardRef as ReactComponent };